import React from 'react';

interface LoadingButtonProps {
  isLoading: boolean;
  onClick: () => void;
  disabled?: boolean;
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  loadingText?: string;
}

export function LoadingButton({
  isLoading,
  onClick,
  disabled,
  children,
  style = {},
  className = 'btn btn-primary',
  loadingText = 'Loading...'
}: LoadingButtonProps) {
  return (
    <button
      onClick={isLoading ? undefined : onClick}
      disabled={disabled || isLoading}
      className={className}
      style={style}
    >
      {isLoading ? (
        <>
          <span className="spinner" />
          {loadingText}
        </>
      ) : children}
    </button>
  );
}
